<script setup lang="ts">
import { ref, watch } from 'vue';

import TimeOfDayInput from './TimeOfDayInput.vue';

const props = withDefaults(
  defineProps<{
    withTime?: boolean;
  }>(),
  { withTime: false },
);

const model = defineModel<string>({ default: '' });
const dueTime = defineModel<string | null>('dueTime', { default: null });

const dateInput = ref<HTMLInputElement | null>(null);

function openPicker(): void {
  const input = dateInput.value;
  if (!input) return;
  if (typeof input.showPicker === 'function') {
    input.showPicker();
  } else {
    input.focus();
    input.click();
  }
}

watch(model, (next) => {
  if (!next) dueTime.value = null;
});
</script>

<template>
  <div
    class="date-field"
    :class="{ 'date-field--with-time': props.withTime }"
  >
    <input
      ref="dateInput"
      v-model="model"
      type="date"
      aria-label="Срок"
    />
    <TimeOfDayInput
      v-if="props.withTime"
      v-model="dueTime"
      class="date-field__time"
      :disabled="!model"
    />
    <button
      type="button"
      class="btn btn--ghost btn--small date-field__trigger"
      aria-label="Выбрать дату"
      title="Выбрать дату"
      @click="openPicker"
    >
      📅
    </button>
  </div>
</template>
